import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 404エラーページコンポーネント
 * 存在しないパスにアクセスした場合に表示
 */
const NotFoundPage = () => {
  const location = useLocation();
  
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>ページが見つかりません</h1>
      <p>お探しのページは存在しません。</p>
      <p style={{ color: 'red' }}><span>要求されたパス: </span><strong>{location.pathname}</strong></p>
      <div style={{ marginTop: '20px' }}>
        <button 
          onClick={() => window.location.href = '/terms'}
          style={{
            background: '#007bff',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          最初からやり直す
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;